import {decodeHtmlEntities as decode} from '@web/helpers/htmlEntities'
import {AddressInfo} from '@web/slices/deliveryInfo/slice'

import {DeliveryAddress, DeliveryAddressBook, Gifting} from '../apis/response/interface'

export const getDeliveryAddressBookByApi = (): DeliveryAddressBook => {
    return {
        defaultDeliveryAddress: null,
        restrictedVirtualPhoneNumbers: [],
        onVirtualPhoneNumber: false,
        recentUsedDeliveryMemosReuse: [],
    }
}

export const getGiftingByApi = (): Gifting => {
    return {
        existsECouponCategoryProduct: false,
        friendsSessionKey: '',
        receivers: [],
        availableGiftingPeopleCount: 1,
        playerKeys: [],
    }
}

export const convertDeliveryAddress = (addressInfo?: Maybe<DeliveryAddress>): Maybe<AddressInfo> => {
    if (!addressInfo) {
        return null
    }

    return {
        hash: addressInfo.addressId,
        addressName: decode(addressInfo.addressName),
        baseAddress: decode(addressInfo.baseAddress),
        detailAddress: decode(addressInfo.detailAddress ?? ''),
        zipCode: addressInfo.zipCode,
        buildingManagementNo: addressInfo.buildingManagementNo ?? null,
        locationX: addressInfo.locationX ?? null,
        locationY: addressInfo.locationY ?? null,
        receiverName: decode(addressInfo.receiverName),
        telNo1: addressInfo.telNo1,
        telNo2: addressInfo.telNo2,
        isPrimaryAddress: addressInfo.primary,
        isRegistered: addressInfo.registered ?? false,
        isRoadNameAddress: addressInfo.road,
        locationType: addressInfo.pickupLocationType,
        locationDescription: addressInfo.pickupLocationContent,
        entryMethodType: addressInfo.entryMethodType,
        entryDescription: addressInfo.entryMethodContent,
    }
}
